import { combineReducers } from 'redux'
import users, * as selectorsFromUser from './users'
import clients, * as selectorsFromClient from './clients'
import auth, * as selectorsFromAuth from './auth'
import testimonials, * as selectorsFromTestimonial from './testimonials'
import banner, * as selectorsFromBanner from './banner'
import blog, * as selectorsFromBlog from './blog'
import config, * as selectorsFromConfig from './config'
import entities, * as selectorsFromEntity from './entities'
import cars, * as selectorsFromCar from './cars'
import contacts, * as selectorsFromContacts from './contact'
import bandeja, * as selectorsFromBandeja from './bandeja'
import solicitudes, * as selectorsFromSolicitudes from './solicitudes'
import bolsa, * as selectorsFromBolsa from './bolsa'
import bolsaSolicitud, * as selectorsFromBolsaSolicitud from './bolsa_solicitud'
import ui, * as selectorsFromUi from './ui'

const rootReducer = combineReducers({
    auth,
    users,
    clients,
    bandeja,
    solicitudes,
    cars,
    testimonials,
    banner,
    blog,
    bolsa,
    bolsaSolicitud,
    entities,
    contacts,
    config,
    ui
})

export const getUsers = (state) => selectorsFromUser.getUsers(state.users)
export const getUser = (state, id) => selectorsFromUser.getUser(state.users, id)

export const getClients = (state) => selectorsFromClient.getClients(state.clients)
export const getClient = (state, id) => selectorsFromClient.getClient(state.clients, id)

export const getCars = (state) => selectorsFromCar.getCars(state.cars)
export const getCar = (state, id) => selectorsFromCar.getCar(state.cars, id)

export const getAuth = (state) => selectorsFromAuth.getAuth(state.auth)
export const getRole = (state) => selectorsFromAuth.getRole(state.auth)

export const getTestimonials = (state) => selectorsFromTestimonial.getTestimonials(state.testimonials)
export const getTestimonial = (state, id) => selectorsFromTestimonial.getTestimonial(state.testimonials, id)

export const getBanners = (state) => selectorsFromBanner.getBanners(state.banner)
export const getBanner = (state, id) => selectorsFromBanner.getBanner(state.banner, id)

export const getPosts = (state) => selectorsFromBlog.getPosts(state.blog)
export const getPost = (state, id) => selectorsFromBlog.getPost(state.blog, id)

export const getBolsas = (state) => selectorsFromBolsa.getBolsas(state.bolsa)
export const getBolsa = (state, id) => selectorsFromBolsa.getBolsa(state.bolsa, id)

export const getBolsaSolicitudes = (state) => selectorsFromBolsaSolicitud.getBolsaSolicitudes(state.bolsaSolicitud)
export const getBolsaSolicitud = (state, id) => selectorsFromBolsaSolicitud.getBolsaSolicitud(state.bolsaSolicitud, id)

export const getConfig = (state) => selectorsFromConfig.getConfig(state.config)
export const getEntity = (state, name) => selectorsFromEntity.getEntity(state.entities, name)

export const getContacts = (state) => selectorsFromContacts.getContacts(state.contacts)
export const getContact = (state, id) => selectorsFromContacts.getContact(state.contacts, id)

export const getBandeja = (state) => selectorsFromBandeja.getBandeja(state.bandeja)
export const getBandejaUsuario = (state, id) => selectorsFromBandeja.getBandejaUsuario(state.bandeja, id)

export const getSolicitudes = (state) => selectorsFromSolicitudes.getSolicitudes(state.solicitudes)
export const getSolicitudesCliente = (state, cliente_id) => selectorsFromSolicitudes.getSolicitudesCliente(state.solicitudes, cliente_id)
export const getSolicitud = (state, id) => selectorsFromSolicitudes.getSolicitud(state.solicitudes, id)

export const getLoader = (state) => selectorsFromUi.getLoader(state.ui)
export const getRedirect = (state) => selectorsFromUi.getRedirect(state.ui)
export const getMenu = (state) => selectorsFromUi.getMenu(state.ui)
export const getActiveToast = (state) => selectorsFromUi.getActiveToast(state.ui)
export const getTableFilter = (state, table) => selectorsFromUi.getTableFilter(state.ui, table)


export default rootReducer